// extracted by mini-css-extract-plugin
export default {"imageWrapper":"HG-z","twoColumnImage":"IG-z"};